import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GradientButtonComponent } from '../../gradient-button/gradient-button.component';

@Component({
	selector: 'app-nux-universal',
	templateUrl: './nux-universal.component.html',
	styleUrls: ['./nux-universal.component.scss'],
	standalone: true,
	imports: [CommonModule, GradientButtonComponent],
})
export class NuxUniversalComponent {
	@Input() caretPosition = '';
	@Input() showBadge = true;
	@Input() description = '';
	@Input() link: string | undefined;
	@Input() learnMoreText = 'Learn More';
	@Input() dismissText = 'Got it!';
	@Output() gotItEvent: EventEmitter<any> = new EventEmitter<any>();
}
